<template>
  <div>    
    <el-select
      v-close-on-zoom
      :value="state.location"
      placeholder="Any location"
      class="pulse-location-select"
      :disabled="readonly"
      @input="location => setLocation(location)"
    >
      <el-option
        label="Any location"
        :value="null"
      />
      <el-option
        v-for="location in pulseLocations"
        :key="location.key"
        :label="location.label.en"
        :value="location.key"
      />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';

import pulseLocations from '~lib/common/config/pulseLocations';

export default {
  name: 'palpate-pulse-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        location: null,
      },
      pulseLocations,
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.location = get(data, 'id') || null;
    this.update();
  },
  methods: {
    setLocation(location) {
      this.state.location = location;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PALPABLE_PULSE',
        id: this.state.location,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>